import React from "react";
import { useForm } from "@ludens-reklame/rubics-v3-react/form/hooks";
import {
  Form as IForm,
  FormField as IFormField,
} from "@ludens-reklame/rubics-v3-sdk/form/types";
import { RichText } from "../../internal-components/rich-text/richText.js";
import { UseInputInterface } from "@ludens-reklame/rubics-v3-react/util/hooks";

interface Props {
  form?: IForm;
  text?: string;
}

export const Form: React.FC<Props> = ({ form, text }) => {
  if (!form) {
    return null;
  }

  const _form = useForm(form);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    _form.submit();
  };

  return (
    <div className="form-component">
      <div className="mw-small">
        {text && (
          <div className="text">
            <RichText html={text} />
          </div>
        )}

        {_form.success ? (
          <Success successText={form.successText} />
        ) : (
          <form className="submit-form" onSubmit={handleSubmit}>
            {form.name && <h4>{form.name}</h4>}
            <div className="fields">
              {form.fields.map((field) => (
                <FormField key={field._id} input={_form} field={field} />
              ))}
            </div>
            <div>
              <button type="submit">{form.submitButtonText}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

interface FormFieldProps {
  field: IFormField;
  input: UseInputInterface;
}

const FormField: React.FC<FormFieldProps> = ({ field, input }) => {
  const renderInput = () => {
    switch (field.type) {
      case "boolean":
        return (
          <div className="consents">
            <label htmlFor={field.name} className="b3">
              {field.required && "*"}
              {field.label}
              <input
                type="checkbox"
                id={field.name}
                name={field.name}
                required={field.required}
                placeholder={field.placeholder}
                onChange={(e) => {
                  input.setField(field.name, e.target.checked);
                }}
              />
            </label>
          </div>
        );
      case "info":
        return (
          <div className="info">
            <RichText html={field.description || ""} />
          </div>
        );
      default:
        return (
          <label htmlFor={field.name} className="b3">
            {field.label}
            {field.required && "*"}
            <input
              type={field.type}
              id={field.name}
              name={field.name}
              required={field.required}
              placeholder={field.placeholder}
              onChange={(e) => {
                input.setField(field.name, e.target.value);
              }}
            />
          </label>
        );
    }
  };

  return <div className="field">{renderInput()}</div>;
};

interface SuccessProps {
  successText?: string;
}

const Success: React.FC<SuccessProps> = ({ successText }) => {
  return (
    <div className="form-success">
      {successText ? (
        <div className="success">
          <RichText html={successText} />
        </div>
      ) : (
        <h2>Takk for din henvendelse!</h2>
      )}
    </div>
  );
};

export default Form;
